import { performGeocode } from './distributor-geocode';
import { getGoogleAPILanguageCode } from './distributor-language';
import { findDistributors } from './distributor-find';
import { DistributorMap } from './DistributorMap';

// does exactly what it says
export const handleDistributorSearchFilterDisabling = async () => {
  const dealerType = document.querySelector<HTMLSelectElement>(
    'select[name="tx_sitepackagesaf_distributersearch[distributor-search-filter__type]"]',
  );
  const skillsElement = document.querySelector(
    'select[name="tx_sitepackagesaf_distributersearch[distributor-search-filter__skills]"]',
  );
  const skillsGroup = document.querySelector(
    'div[name="distributor-search-filter__skills"]',
  );
  if (!dealerType || !skillsElement || !skillsGroup) {
    return;
  }

  if (dealerType.value !== 'Workshop') {
    skillsElement.setAttribute('disabled', 'disabled');
    skillsGroup.children[0]?.classList.add('is-disabled');
  } else {
    skillsElement.removeAttribute('disabled');
    skillsGroup.children[0]?.classList.remove('is-disabled');
  }
};

export const handleDistributorSearch = async (map: DistributorMap) => {
  const form = document.querySelector<HTMLFormElement>(
    'form#distributor-search-filter',
  )!!;

  handleDistributorSearchFilterDisabling();

  const { key, url, distanceUnit } = form.dataset;

  const formData = new FormData(form);

  // Get the values of the filter form elements.
  // They cannot be files because we did not define them as such.
  const address = formData.get(
    'tx_sitepackagesaf_distributersearch[distributor-search-filter__address]',
  ) as string;
  const dealerType = formData.get(
    'tx_sitepackagesaf_distributersearch[distributor-search-filter__type]',
  ) as string;
  const distance = formData.get(
    'tx_sitepackagesaf_distributersearch[distributor-search-filter__distance]',
  ) as string;
  const skills = formData.get(
    'tx_sitepackagesaf_distributersearch[distributor-search-filter__skills]',
  ) as string;

  const geocodingResponse = await performGeocode(
    key!!,
    address,
    getGoogleAPILanguageCode(),
  );
  const geocodingResult = geocodingResponse.results[0];

  if (geocodingResponse.status !== 'OK' || geocodingResult === undefined) {
    return;
  }

  const distributors = await findDistributors(
    url!!,
    dealerType,
    distance,
    distanceUnit!!,
    geocodingResult.geometry.location,
    skills,
  );
  map.setLastAddressQuery(address);

  map.loadLocations(
    distributors,
    geocodingResult.formatted_address,
    geocodingResult.geometry.location,
  );
};
